// extracted by mini-css-extract-plugin
export var content = "MobileContent-module--content--e9851";
export var item = "MobileContent-module--item--42ed8";